import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { EntityChartConfig } from '../entity-chart-config';
import { EntitySetting, EntitySettingGroupModel } from '../../models/entity-setting.model';


@Injectable()
export class EntityChartApiService {
  constructor (private httpClient: HttpClient) {
  }

  getEntitySettings (): Observable<EntitySetting[]> {
    return this.httpClient.get<any>(EntityChartConfig.EntitySettingsApi);
  }

  getEntityCount (): Observable<number> {
    return this.httpClient.get<any>(EntityChartConfig.EntityCountApi);
  }

  getEntityGroupByRegion (): Observable<EntitySettingGroupModel[]> {
    return this.httpClient.get<EntitySettingGroupModel[]>(EntityChartConfig.EntitySettingsGroupByRegionApi);
  }
  getEntityCountByCountry (): Observable<any[]>{
    return this.httpClient.get<any[]>(EntityChartConfig.EntityCountByCountry);
  }
}


